import { ShareRoute } from '@/system-modules/share/v1/api/ShareRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { ILink } from '@/contracts/system-modules/share/ILink'
import { CreateLinkParams } from '@/system-modules/share/v1/api/v1/share/CreateLink/Dto/CreateLinkParams'

export const OFFLINE_LINK_UUID = '00000000-0000-4000-8000-000000000001'

export class CreateLinkRoute extends ShareRoute<CreateLinkParams, ILink> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/share/links'
  }

  /** Без сервера ссылка создаётся с постоянным UUID на правах владельца */
  offline(params: CreateLinkParams): Promise<ApiResponse<ILink>> {
    return Promise.resolve(new ApiResponse({
      success: true,
      data: {
        uuid: OFFLINE_LINK_UUID,
        ownerUuid: params.owner,
        creatorUuid: params.owner,
        responsibleUuid: params.owner,
        parentUuid: null,
        module: params.module,
        target: params.target,
        zone: params.zone,
        expiresAt: params.expiresAt,
        viewCount: 0,
        lastViewedAt: null,
        removedAt: null,
      },
    }))
  }
}
